import { cn } from "@/lib/utils/general";
import { HTMLAttributes, forwardRef } from "react";

type LabelProps = HTMLAttributes<HTMLLabelElement> & {
	htmlFor?: string;
};

const Label = forwardRef<HTMLLabelElement, LabelProps>(
	({ className, htmlFor, ...props }, ref) => (
		<label
			ref={ref}
			htmlFor={htmlFor}
			className={cn(
				"text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
				className
			)}
			{...props}
		/>
	)
);
Label.displayName = "Label";

export { Label };
